module.exports = __webpack_public_path__ + "img/dy.88110d37.png";